import firebase from 'firebase/app'
import 'firebase/messaging'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import AuthService from 'services/auth'
import sha256 from 'crypto-js/sha256'

// Your new Firebase config
const messagingConfig = {
  apiKey: 'AIzaSyBhjirggDYpkJe7e-yL6MQt9NZWN23XzUk',
  authDomain: 'squareboat-service-desk.firebaseapp.com',
  projectId: 'squareboat-service-desk',
  storageBucket: 'squareboat-service-desk.firebasestorage.app',
  messagingSenderId: '160059257157',
  appId: '1:160059257157:web:635bc80a282ba2c8c14e2c',
  measurementId: 'G-8ZK6S9CMKH',
}

const services = new AuthService()
// Initialize a new named app
// let messagingApp
// try {
//   messagingApp = firebase.app('messagingApp') // check if it exists
// } catch (err) {
//   messagingApp = firebase.initializeApp(messagingConfig, 'messagingApp')
// }

// // Get messaging from the new app
// const messaging = messagingApp.messaging()

export const isMessagingSupported = () => {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'localStorage' in window &&
    'indexedDB' in window &&
    firebase?.messaging?.isSupported?.()
  )
}

let appInstance
try {
  appInstance = firebase.app('messagingApp')
} catch (err) {
  appInstance = firebase.initializeApp(messagingConfig, 'messagingApp')
}

// Export a constant binding
// const messagingApp = appInstance // ✅ Export as const
// console.log(messagingApp)
// const messaging = messagingApp.messaging()
let messaging = null
if (isMessagingSupported()) {
  messaging = appInstance?.messaging()
} else {
  console.warn('🚫 Firebase Messaging not supported on this browser.')
}

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window?.MSStream

export function generateId() {
  const arr = new Uint32Array(4)
  crypto.getRandomValues(arr)
  return arr.join('-')
}

// export const getMachineId = async () => {
//   const fp = await FingerprintJS.load()
//   const result = await fp.get()
//   return result.visitorId // This is your "machine ID"
// }

export const getMachineId = async () => {
  const cachedId = localStorage.getItem('machineId')
  if (cachedId) return cachedId

  const fp = await FingerprintJS.load()
  const result = await fp.get()

  // Combine fingerprint attributes
  const { userAgent, language, platform } = navigator
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const rawId = `${result.visitorId}-${userAgent}-${language}-${platform}-${timezone}`
  const hashedId = sha256(rawId).toString()

  localStorage.setItem('machineId', hashedId)
  return hashedId
}

const MACHINE_ID = await getMachineId()

// Replace with your backend URL

// Request permission & get token
export const requestNotificationPermission = async () => {
  try {
    // 1️⃣ Request notification permission
    if (!isMessagingSupported() || isIOS()) {
      console.warn('🚫 Push notifications not supported on this device/browser.')
      return null
    }

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      console.warn('⚠️ Notification permission not granted')
      return null
    }

    // 2️⃣ Ensure service worker is ready
    if (!('serviceWorker' in navigator)) {
      console.warn('⚠️ Service Worker not supported')
      return null
    }

    if (!isMessagingSupported()) {
      console.warn('🚫 Firebase Messaging is not supported in this browser')
      return null
    }

    const swRegistration = await navigator.serviceWorker.ready

    // 3️⃣ Get FCM token
    const token = await messaging.getToken({
      vapidKey:
        'BOJfRCuyk0pL0MW8qWXSmDlwsEYdDbfaExIeaH4w6xFL3eViXWAt3R5BHEMqWWyBpe_NEsRM5I93JSarILHKu54',
      serviceWorkerRegistration: swRegistration,
    })
    try {
      const authToken = localStorage.getItem('authToken')
      if (authToken) {
        await services.addDevice({ body: { fcmToken: token, machineId: MACHINE_ID } })
        localStorage.setItem('fcmToken', token)
      }
    } catch (err) {
      console.log('Error', err)
    }
    if (!token) {
      console.warn('⚠️ FCM token not available')
      localStorage.removeItem('fcmToken')
      return null
    }

    // 4️⃣ Check if token changed
    const storedToken = localStorage.getItem('fcmToken')
    if (storedToken !== token) {
      // Try registering with backend, safely
      try {
        if (localStorage.getItem('accessToken')) {
          await services.addDevice({ body: { fcmToken: token, machineId: MACHINE_ID } })
          localStorage.setItem('fcmToken', token)
        }
      } catch (err) {
        console.error('❌ Failed to register token with backend:', err)
      }
    } else {
      console.log('ℹ️ FCM token unchanged')
    }

    return token
  } catch (err) {
    // Handle Firebase-specific errors
    if (err.code === 'messaging/failed-serviceworker-registration') {
      console.error('❌ Service Worker registration failed:', err)
    } else if (err.code === 'messaging/permission-blocked') {
      console.error('❌ Notifications blocked by user:', err)
    } else {
      console.error('❌ Error getting FCM token:', err)
    }

    localStorage.removeItem('fcmToken')
    return null
  }
}

export const onMessageListener = (callback) => {
  if (!messaging) {
    console.warn('⚠️ Firebase Messaging not initialized')
    return () => {}
  }

  // Wait for service worker to be ready
  // navigator.serviceWorker.ready
  //   .then((registration) => {

  messaging.onMessage((payload) => {
    // Handle both data and notification payloads
    let messageData = null

    if (payload.data) {
      messageData = {
        title: payload.data.title,
        body: payload.data.body,
        icon: payload.data.icon || '/firebase-logo.png',
      }
    } else if (payload.notification) {
      messageData = {
        title: payload.notification.title,
        body: payload.notification.body,
        icon: payload.notification.icon || '/firebase-logo.png',
      }
    }

    if (messageData && callback) callback(messageData)
  })

  // No-op cleanup for Firebase 8
  return () => {}
}
